module.exports = __webpack_public_path__ + "img/sample-doc.3b82e065.png";